import { useShowPagedCustomItems } from "../../hooks"
import { ShowCustomArticleListItemsRequest } from "../models"
import { showCustomArticleListItems } from "../showCustomArticleListItems"
import { QUERY_KEY_ARTICLES } from "./keys"

export function useShowCustomArticleListItems(request: Omit<ShowCustomArticleListItemsRequest, "pageIndex" | "pageSize">, enabled?: boolean) {
    return useShowPagedCustomItems(
        request,
        { queryKey: [QUERY_KEY_ARTICLES, request.id, request.query], dataFn: showCustomArticleListItems },
        enabled
    )
}
